module.exports = __webpack_public_path__ + "static/media/material-handling.e492c88c.jpg";